import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { BaseListCombinedService } from '../../../../../@core/services/base-list-combined.service';
import { I18nService } from '../../../../../@core/services/i18n/i18n.service';
import { BaseDetailComponent } from '../../../../../common/base-detail.component';
import { WidgetAddActivityControlComponent } from '../widget-add-activity-control/widget-add-activity-control.component';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-formly-add-activity-control',
    templateUrl: './formly-add-activity-control.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        CommonModule,
        WidgetAddActivityControlComponent
    ]
})
export class FormlyAddActivityControlComponent extends FieldType {


}
